// src/hooks/usePublishSubmission.js

import { useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "../firebase"; // Import your Firestore instance

const usePublishSubmission = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const publishSubmission = async (
    draftId,
    { title, description, fundingGoal, tags }
  ) => {
    setLoading(true);
    setError(null);

    try {
      const draftDocRef = doc(db, "submissions", draftId);
      await updateDoc(draftDocRef, {
        title,
        description,
        fundingGoal,
        tags,
        status: "published",
        updatedAt: new Date(),
      });
      setLoading(false);
      return true; // Indicate success
    } catch (err) {
      console.error("Error publishing submission:", err);
      setError("Failed to publish submission. Please try again.");
      setLoading(false);
      return false; // Indicate failure
    }
  };

  return { publishSubmission, loading, error };
};

export default usePublishSubmission;
